import { useNavigate } from "react-router-dom";
import { navigateToNew } from "utilities/js/NavigationHelper";
import { getBracketDraft } from "utilities/js/localstorage/StorageHelper_BracketDraft";
import { setBracketDraft } from "utilities/js/localstorage/StorageHelper_BracketDraft";
import { useState } from "react";
import SimplePrompt from "./SimplePrompt";
import Constants from "utilities/js/Constants";

const deleteIcon = Constants.ICON_DELETE;

const DraftPrompt = (props) => {
    const [draft, setDraft] = useState(getBracketDraft())
    const navigate = useNavigate();

    function openDraft(){
        navigateToNew({routerNav: navigate});
    }

    function deleteDraft(){
        setBracketDraft(null);
        setDraft(null);
        if(props.onDelete){
            props.onDelete();
        }
    }

    if(draft){
        return (<SimplePrompt message="Pick up where you left off" actions={
            <>
                <button className="nav-button-red h-button" onClick={deleteDraft}><img src={deleteIcon} className="delete-icon delete-icon-white"></img></button>
                <button className="nav-button h-button" onClick={openDraft}>Open Draft</button>
            </>
        }></SimplePrompt>)
    }else{
        return (<></>)
    }

}

export default DraftPrompt;